"use strict";
checkList.classy.controller({
    name: 'BusinessIncomeReportedController',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService', '$rootScope'],
    init: function () {

        this.$.ApplicationService = this.ApplicationService;
        this.$.helpCardMessage = '<div ng-include="" data-src=" \'fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/checkList/partials/businessIncomeExplained.html\' "></div>';

        let verifiedAnnualIncome = this.annualIncome();
        this.$.businessIncome = this.netBusinessIncome();
        this.$.incomeNeededForHousing = this.ApplicationService.getFamilyData().awardData.housing.housing / .3;
        this.$.businessIncomeForHousing = (this.$.incomeNeededForHousing - verifiedAnnualIncome - this.ApplicationService.getFamilyData().edit_sums.Inc_Estate  < 0) ?
            0 :  this.$.incomeNeededForHousing - verifiedAnnualIncome - this.ApplicationService.getFamilyData().edit_sums.Inc_Estate;

        // If choice is already made, select that choice
        if (this.ApplicationService.getFamilyData().apWizard['case66ans'].length > 1)
            this.$.answer = JSON.parse(this.ApplicationService.getFamilyData().apWizard['case66ans']);
        else { // Otherwise select highest of the three options
            if (this.ApplicationService.getFamilyData().bizIncCalc.businessIncome > this.ApplicationService.getFamilyData().income.Inc_Business
                && this.ApplicationService.getFamilyData().bizIncCalc.businessIncome > this.$.businessIncome)
                this.$.answer = { choice: 0 }; // ISM Determined
            else if (this.ApplicationService.getFamilyData().income.Inc_Business > this.$.businessIncome)
                this.$.answer = { choice: 1 }; // Family Reported
            else
                this.$.answer = { choice: 2 }; // Net Bus inc on taxes
        }
    },
    annualIncome: function() {
        var inc1 = this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 ? this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 : 0;
        var inc2 = this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 ? this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 : 0;
        return parseInt(inc1) +  parseInt(inc2);
    },
    netBusinessIncome: function() {
        if (this.ApplicationService.getFamilyData().bizIncLines.length>0 && this.ApplicationService.getFamilyData().data[0].Fam_Country === "United States") {
            return parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line12']) +
                parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line17']) +
                parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line18']);
        } else if (this.ApplicationService.getFamilyData().data[0].Fam_Country === "Canada")  {
            return parseInt(this.ApplicationService.getFamilyData().ism_edits.ISM_Business);
        } else {
            return 0;
        }
    },
    businessIncomeReportedComplete: function () {
        if (this.$.answer.choice != 3)
            delete this.$.answer.amount;

        if (this.$.answer.choice == 0)
            this.ApplicationService.getFamilyData().edit_sums.Inc_Business = this.ApplicationService.getFamilyData().bizIncCalc.businessIncome;
        else if (this.$.answer.choice == 1)
            this.ApplicationService.getFamilyData().edit_sums.Inc_Business = this.ApplicationService.getFamilyData().income.Inc_Business;
        else if (this.$.answer.choice == 2)
            this.ApplicationService.getFamilyData().edit_sums.Inc_Business = this.netBusinessIncome() > 0 ? this.netBusinessIncome() : 0;
        else
            this.ApplicationService.getFamilyData().edit_sums.Inc_Business = this.$.answer.amount;

        this.$.alertPut([this.PutService.putEditSums()], 'case66', 0, this.$.answer);
    }
});
